import React from 'react';
import SettingsPage from '@/components/Settings/SettingsPage';

const SettingsPageWrap = () => <SettingsPage />;

export default SettingsPageWrap;
